import React from 'react'
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { regEx } from '../../../../resources/Utils';

const CustomerInfo = ({customerInfo, isEPayment, onChange, disableByMerchantInfo, disableByCustomerInfo, onClickFindCustomer, action}) => {
    return (
        <React.Fragment>
            <Row className="mt-5">
                <Col sm={12} className="font-weight-bold">
                    Customer Information
                </Col>
            </Row>
            <Row className="my-3">
                <Col sm={12}>
                    <Row>                    
                        <Col sm={6}>
                            <Form.Group controlId="customerId">
                                <Form.Label className="text-grey font-weight-bold medium required">Tax ID</Form.Label>
                                <InputGroup>                                
                                <Form.Control
                                    name="customerId" type="text" placeholder="Enter tax ID"
                                    pattern="\d{10,13}"
                                    maxLength="13"
                                    title="tax ID must be 13 digits only"
                                    value={customerInfo ? customerInfo.customerId : ''}
                                    onChange={(e) => onChange('customerInfo', e.target.name, e.target.value, "NUMERIC")}
                                    disabled={disableByMerchantInfo}
                                    form="customerFindingForm"
                                    required
                                />
                                {action === 'create' &&
                                <InputGroup.Append>
                                    <Button form="customerFindingForm" onClick={onClickFindCustomer} disabled={disableByMerchantInfo} type="submit" variant="secondary">
                                        <FontAwesomeIcon size="lg" icon={faSearch}/>
                                    </Button>
                                </InputGroup.Append>
                                }
                                </InputGroup>
                            </Form.Group>
                        </Col>                          
                        <Col sm={6}>
                            <Form.Group controlId="fullName">
                            <Form.Label className="text-grey font-weight-bold medium">Contact's Full Name</Form.Label>
                            <Form.Control
                                name="fullName" type="text"
                                placeholder="Enter contact's full name"
                                disabled={disableByCustomerInfo}
                                onChange={(e) => onChange('customerInfo', e.target.name, e.target.value)}
                                value={customerInfo ? customerInfo.fullName : ''}
                            />
                            </Form.Group>
                        </Col>     
                    </Row>
                    <Row>                            
                        <Col sm={6}>
                            <Form.Group controlId="contactNumber">
                            <Form.Label className="text-grey font-weight-bold medium">Contact's Phone Number</Form.Label>
                            <Form.Control
                                name="contactNumber" type="text"
                                placeholder="Enter contact's phone number"
                                maxLength={10}
                                pattern={regEx.DECIMAL}
                                title="Phone Number should be 10 digits"
                                disabled={disableByCustomerInfo}
                                onChange={(e) => onChange('customerInfo', e.target.name, e.target.value, "NUMERIC")}
                                value={customerInfo ? customerInfo.contactNumber : ''}
                            />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="email">
                            <Form.Label className={"text-grey font-weight-bold medium " + (isEPayment? "required" : "")}>Contact's Email Address</Form.Label>
                            <Form.Control
                                name="email" type="text"
                                placeholder="Enter contact's email address"
                                pattern={regEx.EMAIL}
                                title="Email is invalid format"
                                disabled={disableByCustomerInfo}
                                onChange={(e) => onChange('customerInfo', e.target.name, e.target.value)}
                                value={customerInfo ? customerInfo.email : ''}
                                required = {isEPayment}
                            />
                            </Form.Group>
                        </Col>                       
                    </Row>
                    <Row>                            
                        <Col sm={6}>
                            <Form.Group controlId="companyName">
                            <Form.Label className="text-grey font-weight-bold medium">Company Name</Form.Label>
                            <Form.Control
                                name="companyName" type="text"
                                placeholder="Enter company name"
                                disabled={true}
                                onChange={(e) => onChange('customerInfo', e.target.name, e.target.value)}
                                value={customerInfo ? customerInfo.companyName : ''}
                            />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group controlId="corporateId">
                            <Form.Label className="text-grey font-weight-bold medium">Corporate ID</Form.Label>
                            <Form.Control
                                name="corporateId" type="text"
                                placeholder="Enter corporate ID"
                                disabled={disableByCustomerInfo}
                                onChange={(e) => onChange('customerInfo', e.target.name, e.target.value)}
                                value={customerInfo ? customerInfo.corporateId : ''}
                            />
                            </Form.Group>
                        </Col>                       
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default CustomerInfo
